module.exports = __webpack_public_path__ + "a32db5d0b755193837f5d637761529c0.svg";